import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/assets/js/constants';

type AddressCardImageType = {
    image: string,
}

export const AddressCard = styled.div`
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    border-radius: 16px;
    padding: 24px;
    width: 32.4%;
    height: 236px;
    margin-bottom: 0;
    
    @media (max-width: 1024px) { 
        width: calc(96% / 3);
        height: 288px;
        padding: 24px;
    }

    @media (max-width: 760px) { 
        display: flex;
        flex-direction: inherit;
        padding: 24px 59px 24px 24px;
        width: 100%;
        height: 220px;
    }

    @media (max-width: 535px) { 
        height: fit-content;
        margin-bottom: 16px;
    }

    &:last-child { 
        margin-right: 0;
        margin-bottom: 0;
    }
`;

export const AddressCardImage = styled.div<AddressCardImageType>`
    background-position: left;
    background-image: ${props => `url(${props.image})`};
    float: left;
    background-repeat: no-repeat;
    background-size: contain;
    width: 64px;
    height: 64px;
    display: block;
`;

export const AddressCardDescription = styled.div`
    display: block;
    ${FONTS.XL}; 

    @media (max-width: 1280px) { 
        margin-top: 16px;
    }

    @media (max-width: 1024px) {
        ${FONTS.L}; 
        margin-top: 16px;
    }

    @media (max-width: 535px) {
        ${FONTS.M}; 
        margin-top: 16px;
    }
`;
